import { Stack } from '@moda/om';
import classNames from 'classnames';
import React from 'react';
import { useUrlParams } from '../../../hooks/useUrlParams';
import { LooksCarouselItemHeader } from '../LooksCarouselItemHeader';
import { LooksCarouselItemVariants } from '../LooksCarouselItemVariants';

import './LooksCarouselItemDetails.scss';

interface Props {
  className?: string;
  lookId: string;
}

export const LooksCarouselItemDetails: React.FC<Props> = ({ className, lookId }) => {
  const {
    queryParams: { look: selectedLookId }
  } = useUrlParams();

  const isSelected = selectedLookId === lookId;

  if (!isSelected) return null;

  return (
    <Stack className={classNames('LooksCarouselItemDetails', className)} space={4}>
      <LooksCarouselItemHeader />

      <LooksCarouselItemVariants lookId={lookId} />
    </Stack>
  );
};
